import { render, staticRenderFns } from "./commonMoralEvaluationEntrance.vue?vue&type=template&id=4fd950e6&scoped=true"
import script from "./commonMoralEvaluationEntrance.vue?vue&type=script&lang=js"
export * from "./commonMoralEvaluationEntrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd950e6",
  null
  
)

export default component.exports